import type { ResponseAcademicRisk } from '@/domains/academicRisk';
import { ApiEndPoint } from '@/domains/api/api.entity';
import { apiRequest } from './apiRequest';

/**
 * Servicio API para consulta de estudiantes en riesgo académico
 * Responsable de las comunicaciones HTTP relacionadas con la obtención de datos
 * de estudiantes con mediciones de riesgo académico identificadas
 */
class AcademicRiskStudentApiService {
  /**
   * Obtiene todos los estudiantes con riesgos académicos identificados
   * Los datos se organizan jerárquicamente por año académico y semestre
   */
  async getAcademicRiskStudent(): Promise<ResponseAcademicRisk> {
    const academicRiskStudetnResponse =
      await apiRequest.get<ResponseAcademicRisk>({
        route: ApiEndPoint.ACADEMIC_RISK,
        // params: { anio: 2026 },
        // params: { anio: 2026, periodo: 1 }, // -> ver si se implementará
      });

    return academicRiskStudetnResponse;
  }
}

export const academicRiskStudentApiService =
  new AcademicRiskStudentApiService();
